"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Hitagi_Plugin_Im {
    //====================================================================
    // Plugin Im API
    //====================================================================
    constructor(HitagiInstance) {
        this.AccessCallbacks = [];
        this.hitagi = HitagiInstance;
    }
    post_message(Message, To, Success, Error) {
        this.hitagi.log("Sending Message");
        const Packet = {
            "plugin": "im",
            "action": "message",
            "args": { "message": Message, "to": To }
        };
        this.hitagi.send(Packet, Success, Error);
    }
    access_check(To, Success) {
        this.hitagi.log("Checking access to im with" + To);
        const Packet = {
            "plugin": "im",
            "action": "access_check",
            "args": { "to": To }
        };
        this.hitagi.send(Packet, Success);
    }
    access_request(To, Success, Error) {
        this.hitagi.log("Requesting access to im with " + To);
        const Packet = {
            "plugin": "im",
            "action": "access_request",
            "args": { "to": To }
        };
        const CallbackInstance = {
            "ufrag": To,
            "success": Success,
            "deny": Error
        };
        this.AccessCallbacks.push(CallbackInstance);
        this.hitagi.send(Packet);
    }
    access_allow(To) {
        this.hitagi.log("Allowing to im with " + To);
        const Packet = {
            "plugin": "im",
            "action": "access_allow",
            "args": { "to": To }
        };
        this.hitagi.send(Packet);
    }
    access_allow_brief(To) {
        this.hitagi.log("Allowing to im with " + To);
        const Packet = {
            "plugin": "im",
            "action": "access_allow_brief",
            "args": { "to": To }
        };
        this.hitagi.send(Packet);
    }
    access_reset(To, Reason) {
        if (!Reason)
            Reason = "reset";
        this.hitagi.log("Resetting im access to " + To);
        const Packet = {
            "plugin": "im",
            "action": "access_reset",
            "args": { "to": To, "reason": Reason }
        };
        this.hitagi.send(Packet);
    }
    access_deny(To) {
        this.hitagi.log("Denying to im with " + To);
        const Packet = {
            "plugin": "im",
            "action": "access_deny",
            "args": { "to": To }
        };
        this.hitagi.send(Packet);
    }
    send_typing_notify(To, Success, Error) {
        this.hitagi.action("im", "send_typing_notify", { "to": To }, Success, Error);
    }
    status(To, Success, Error) {
        this.hitagi.action("im", "status", { "to": To }, Success, Error);
    }
    delete_history(To, Success, Error) {
        this.hitagi.action("im", "delete_history", { "to": To }, Success, Error);
    }
    mark_read(From, Success, Error) {
        this.hitagi.action("im", "mark_read", { "from": From }, Success, Error);
    }
    markRead(From, Success, Error) {
        this.hitagi.action("im", "mark_read", { "from": From }, Success, Error);
    }
    load_messages(From, Direction, FilterId, Success, Error) {
        this.hitagi.action("im", "load_messages", { "from": From, "direction": Direction, "filter_id": FilterId }, Success, Error);
    }
    //====================================================================
    // Plugin Im events
    //====================================================================
    on_message(Func) {
        this.hitagi.on("im:message", Func);
    }
    on_access_request(Func) {
        this.hitagi.on("im:access_request", Func);
    }
    on_access_changed(Func) {
        this.hitagi.on("im:access_changed", Func);
    }
    //====================================================================
    // Plugin Im server callbacks
    //====================================================================
    callback__message(Message) {
        this.hitagi.fire_event("im:message", Message);
    }
    callback__access_request(Args) {
        this.hitagi.fire_event("im:access_request", Args);
    }
    callback__access_changed(Args) {
        this.hitagi.fire_event("im:access_changed", Args);
        const that = this;
        this.AccessCallbacks.forEach(function (Callback, Index) {
            if (Callback.ufrag == Args.to) {
                if (Args.access == "allow") {
                    Callback.success(Args);
                }
                else {
                    Callback.deny(Args);
                }
                that.AccessCallbacks.splice(Index, 1);
            }
        });
    }
    callback__typing_notify(Args) {
        this.hitagi.fire_event("im:typing_notify", Args);
    }
    callback__history_deleted(Args) {
        this.hitagi.fire_event("im:history_deleted", Args);
    }
}
exports.default = Hitagi_Plugin_Im;
